import { render } from "./lessons-index.vue?vue&type=template&id=524e51e6"
import script from "./lessons-index.vue?vue&type=script&lang=js"
export * from "./lessons-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__